import './App.css';
import useReveal from './useReveal';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Industries from './components/Industries';
import Pricing from './components/Pricing';
import PayrollPricing from './components/PayrollPricing';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  useReveal();

  return (
    <div className="site" id="top">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Industries />
        <Pricing />
        <PayrollPricing />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
